export default __webpack_public_path__ + "static/media/land.69621646.png";